module.exports = __webpack_public_path__ + "img/MMV-100.69b6c7b9.png";